<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        class="screenInput"
        v-model="screen.park_id"
        placeholder="请选择园区"
        v-if="userInfo.park_id == 0"
      >
        <el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <!-- <el-select
        filterable
        class="screenInput"
        v-model="screen.company_id"
        placeholder="请选择企业"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in companyList"
          :key="index"
        ></el-option>
      </el-select> -->
      <el-select
        filterable
        class="screenInput"
        v-model="screen.cancel_user_type"
        placeholder="请选择取消人类型"
      >
        <el-option label="全部取消人类型" value=""></el-option>
        <el-option label="后台" value="1"></el-option>
        <el-option label="下单本人" value="2"></el-option>
      </el-select>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.serve_status"
        placeholder="请选择服务状态"
      >
        <el-option label="全部服务状态" value=""></el-option>
        <el-option label="待服务" value="1"></el-option>
        <el-option label="已完成" value="2"></el-option>
        <el-option label="已取消" value="3"></el-option>
        <el-option label="已评价" value="4"></el-option>
      </el-select>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.property_service_id"
        placeholder="请选择物业服务"
      >
        <el-option label="全部物业服务" value=""></el-option>
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in propertyList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.order_no"
        placeholder="请输入订单编号"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.name"
        placeholder="请输入预约人姓名"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.phone"
        placeholder="请输入预约人手机号"
        maxlength="11"
      ></el-input>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.user_id"
        placeholder="请选择下单用户"
      >
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in userList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.system_admin_id"
        placeholder="请选择后台取消人员"
      >
        <el-option
          :label="item.username"
          :value="item.id"
          v-for="(item, index) in adminUserList"
          :key="index"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="(screen.page = 1), fetchData()" style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="服务状态" width="100">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.serve_status == 1
                ? 'info'
                : scope.row.serve_status == 2
                ? 'success'
                : scope.row.serve_status == 3
                ? 'danger'
                : scope.row.serve_status == 4
                ? ''
                : ''
            "
            disable-transitions
            >{{
              scope.row.serve_status == 1
                ? "待服务"
                : scope.row.serve_status == 2
                ? "已完成"
                : scope.row.serve_status == 3
                ? "已取消"
                : scope.row.serve_status == 4
                ? "已评价"
                : ""
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="订单编号" min-width="210">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.order_no }}</div>
        </template>
      </el-table-column>
      <el-table-column label="订单创建" min-width="180">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.create_time }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="封面图" width="150" align="center">
        <template slot-scope="scope">
          <el-image
            v-for="(img, ind) in scope.row.picurl.split(',')"
            :key="ind"
            style="width: 120px; height: 40px; margin: 0 5px 5px 0"
            :src="imageOss + img"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.picurl.split(','))"
          >
          </el-image>
        </template>
      </el-table-column> -->
      <el-table-column label="服务名称" min-width="110">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.snapshot ? scope.row.snapshot.title : "" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="预约人姓名" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预约人手机号" min-width="130">
        <template slot-scope="scope">
          {{ scope.row.phone }}
        </template>
      </el-table-column>
      <el-table-column label="取消人类型" width="150">
        <template slot-scope="scope">
          <span>{{
            scope.row.cancel_user_type == 1
              ? "后台"
              : scope.row.cancel_user_type == 2
              ? "下单本人"
              : "--"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="取消人" width="150">
        <template slot-scope="scope">
          <span>{{
            scope.row.cancel_user_type == 1
              ? scope.row.system_admin.username
              : scope.row.cancel_user_type == 2
              ? scope.row.user.name
              : "--"
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="取消时的备注" width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.cancel_content }}</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="getInfo(scope.row.id)"
            v-if="roles.includes('/property/order_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="finish(scope.row.id)"
            v-if="
              roles.includes('/property/order_finish') &&
              scope.row.serve_status == 1
            "
            >完成</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="cancel(scope.row.id)"
            v-if="
              roles.includes('/property/order_cancel') &&
              scope.row.serve_status == 1
            "
            >取消</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="seeComment(scope.row)"
            v-if="
              roles.includes('/property/comment_lists') &&
              scope.row.serve_status == 4
            "
            >查看评论</el-button
          >
          <!-- v-if="roles.includes('/property/comment_lists')" -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer size="700px" title="查看" :visible.sync="drawer" direction="rtl">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="企业">
          <el-select filterable v-model="ruleForm.company_id" disabled>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in companyList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="订单编号">
          <el-input v-model="ruleForm.order_no" disabled></el-input>
        </el-form-item>
        <el-form-item label="预约人姓名">
          <el-input v-model="ruleForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="预约人手机号">
          <el-input v-model="ruleForm.phone" disabled maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="服务状态">
          <el-select disabled v-model="ruleForm.serve_status">
            <el-option label="待服务" :value="1"></el-option>
            <el-option label="已完成" :value="2"></el-option>
            <el-option label="已取消" :value="3"></el-option>
            <el-option label="已评价" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="ruleForm.serve_status == 3">
          <el-form-item label="取消人类型">
            <el-select
              disabled
              filterable
              class="screenInput"
              v-model="ruleForm.cancel_user_type"
              placeholder="请选择取消人类型"
            >
              <el-option label="后台" :value="1"></el-option>
              <el-option label="下单本人" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="后台取消人"
            v-if="ruleForm.cancel_user_type == 1"
          >
            <el-select
              filterable
              class="screenInput"
              v-model="ruleForm.system_admin_id"
              placeholder="请选择后台取消人员"
            >
              <el-option
                :label="item.username"
                :value="item.id"
                v-for="(item, index) in adminUserList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="取消时间">
            <el-date-picker
              disabled
              v-model="ruleForm.cancel_time"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="取消时的备注">
            <el-input
              type="textarea"
              v-model="ruleForm.cancel_content"
              disabled
            ></el-input>
          </el-form-item>
        </div>
        <div v-if="ruleForm.snapshot">
          <el-form-item label="服务标题" prop="title">
            <el-input
              disabled
              v-model="ruleForm.snapshot.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="服务收价方式" prop="type">
            <el-radio-group v-model="ruleForm.snapshot.type" disabled>
              <el-radio :label="1">面议</el-radio>
              <el-radio :label="2">标价</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="服务价格"
            prop="price"
            v-if="ruleForm.snapshot.type == 2"
          >
            <el-input
              class="w4"
              disabled
              v-model="ruleForm.snapshot.price"
            ></el-input>
          </el-form-item>
          <el-form-item label="服务标签">
            <el-input disabled v-model="ruleForm.snapshot.des"></el-input>
          </el-form-item>
          <el-form-item label="服务详情" prop="details">
            <Editor
              disabled
              ref="myQuillEditor"
              style="width: 100%"
              v-model="ruleForm.snapshot.details"
            />
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer
      size="700px"
      title="查看评论"
      :visible.sync="commentDrawer"
      direction="rtl"
    >
      <el-form
        :model="commentInfo"
        ref="commentInfo"
        label-width="120px"
        class="demo-ruleForm"
      >
        <div v-if="commentInfo.comment">
          <el-form-item label="评论星级">
            <el-rate
              class="rate-form"
              v-model="commentInfo.comment.star"
              disabled
            >
            </el-rate>
          </el-form-item>
          <el-form-item label="评论图片">
            <el-upload
              ref="upload"
              name="file[]"
              :data="{ type: 'image' }"
              :action="ossUpload"
              :file-list="commentInfo.commentFile"
              list-type="picture-card"
              disabled
              accept=".jpg,.png,.jpeg"
              :class="commentInfo.commentFile.length > 0 ? 'hide' : ''"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="评论内容">
            <el-input
              type="textarea"
              v-model="commentInfo.comment.details"
              disabled
            ></el-input>
          </el-form-item>

          <div v-if="commentInfo.reply">
            <el-form-item label="回复" prop="title">
              <el-input
                type="textarea"
                v-model="commentInfo.reply.details"
                disabled
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button
              type="primary"
              @click="reply()"
              v-if="
                roles.includes('/property/comment_reply') && !commentInfo.reply
              "
            >
              回复
            </el-button>
            <el-button type="info" @click="commentDrawer = false"
              >关闭</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>
    <el-dialog title="回复" :visible.sync="dialogVisible" width="500px">
      <el-form ref="replyForm" :model="replyForm" label-width="80px">
        <el-form-item prop="reason" label="回复内容">
          <el-input type="textarea" v-model="replyForm.details"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('replyForm')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Editor from "@/components/Editor";
import { mapGetters } from "vuex";
import { openPark, openAgoUser, adminUser } from "@/api/index";

import {
  order_lists,
  order_info,
  get_property_service_lists,
  order_cancel,
  order_finish,
  comment_lists,
  comment_reply,
} from "@/api/property";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      ossUpload: this.$store.state.ossUpload,
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        order_no: "",
        property_service_id: "",
        user_id: "",
        // company_id: "",
        phone: "",
        name: "",
        serve_status: "",
        cancel_user_type: "",
        system_admin_id: "",
      },

      parkList: [],
      // companyList: [],
      userList: [],
      adminUserList: [],
      propertyList: [],
      listLoading: true,
      list: [],
      total: 0,
      drawer: false,
      ruleForm: {},
      commentDrawer: false,
      commentInfo: {
        commentFile: [],
        comment: {},
        replyFile: [],
        reply: "",
      },
      replyForm: {
        details: "",
      },
      dialogVisible: false,
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      // this.getRole(this.userInfo.park_id);
    } else {
      // this.getCompany();
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
    // this.getCompany();
    this.getUser();
    this.getProperty();
    this.getAdminUserList();
  },
  methods: {
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              comment_reply(that.replyForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.dialogVisible = false;
                  that.commentDrawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 评论回复
    reply(val) {
      var that = this;
      this.replyForm = {
        pid: that.commentInfo.comment.id,
        property_service_id: that.commentInfo.comment.property_service_id,
        property_service_order_id:
          that.commentInfo.comment.property_service_order_id,
        park_id: that.commentInfo.comment.park_id,
        system_admin_id: this.userInfo ? this.userInfo.id : "",
        details: "",
      };
      this.dialogVisible = true;
      return;
      var that = this;
      const data = {
        id: id,
      };
      this.$confirm("确认取消订单？")
        .then((_) => {
          order_cancel(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            } else {
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    seeComment(val) {
      var that = this;
      this.commentInfo = {
        commentFile: [],
        comment: {},
        replyFile: [],
        reply: "",
      };
      let data = {
        object: "property_service_order",
        property_service_order_id: val.id,
        // type:1
      };

      comment_lists(data).then((res) => {
        let list = res.data.lists.data;
        list.forEach((item) => {
          if (item.type == 1) {
            item.star = +item.star
            that.commentInfo.comment = item;
            if (item.image) {
              var list = item.image.split(",");
              that.commentInfo.commentFile = list.map((item) => {
                return {
                  name: +new Date(),
                  url: that.imageOss + item,
                  response: {
                    data: {
                      url: item,
                    },
                  },
                };
              });
            }
          } else if (item.type == 2) {
            that.commentInfo.reply = item;
            if (item.image) {
              var list = item.image.split(",");
              that.commentInfo.replyFile = list.map((item) => {
                return {
                  name: +new Date(),
                  url: that.imageOss + item,
                  response: {
                    data: {
                      url: item,
                    },
                  },
                };
              });
            }
          }
        });
        this.commentDrawer = true;
      });
    },
    // 订单取消
    cancel(id) {
      var that = this;
      const data = {
        id: id,
      };
      this.$confirm("确认取消订单？")
        .then((_) => {
          order_cancel(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            } else {
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 完成
    finish(id) {
      var that = this;
      const data = {
        id: id,
      };
      this.$confirm("确认完成订单？")
        .then((_) => {
          order_finish(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 查看详情
    getInfo(id) {
      var that = this;
      order_info({ id: id }).then((res) => {
        that.ruleForm = res.data.info;

        that.drawer = true;
      });
    },
    // 筛选园区选择
    parkChange(e) {
      this.screen.company_id = "";
      // this.getCompany(e);
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // // 获取企业列表
    // getCompany(id) {
    //   var data = {
    //     park_id: id,
    //     is_page: 2,
    //   };
    //   openCompany(data).then((response) => {
    //     this.companyList = response.data.lists;
    //   });
    // },
    // 获取物业服务
    getProperty() {
      get_property_service_lists({ is_page: 2 }).then((res) => {
        this.propertyList = res.data.lists;
      });
    },
    // 获取用户列表
    getUser() {
      // var data = {
      //   park_id: this.screen.park_id,
      //   company_id: id,
      // };
      openAgoUser({is_youke:2}).then((response) => {
        this.userList = response.data.lists.data;
      });
    },
    // 获取后台用户列表
    getAdminUserList() {
      adminUser().then((response) => {
        this.adminUserList = response.data.lists.data;
      });
    },
    // 分页
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 重置
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        order_no: "",
        property_service_id: "",
        user_id: "",
        // company_id: "",
        phone: "",
        name: "",
        serve_status: "",
        cancel_user_type: "",
        system_admin_id: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 获取列表
    fetchData() {
      this.listLoading = true;
      order_lists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .screenInput {
    width: 200px;
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
::v-deep .rate-form {
  height: 100%;
  line-height: inherit;
  .el-rate__item {
    font-size: 14px !important;
  }
}
</style>
